import { useSensors, useSensor, TouchSensor, MouseSensor, KeyboardSensor, DndContext } from '@dnd-kit/core';
import { useRef, useState, useMemo } from 'react';
import { groupTileInput } from '@utils/component-framework';
import { NoSSR } from '@utils/react';
import { useComponentRootRef } from '../../../../context.js';
import { useUpdateTaskEntryMutation } from '../../../../state/mutations/update-task-entry.js';
import { TaskAutoScroller } from '../../../../utils/dnd-kit.auto-scroll.js';
import { makeRestrictToRef } from '../../../../utils/dnd-kit.restrict-to-container.js';
import { OpgavekompleksetTaskDragOverlay } from '../../../atom.drag-overlay/_drag-overlay.js';
import { GroupTile } from './atom.tile.js';
import { TileDrawer } from './molecule.drawer.js';
import { DropzoneContainer } from './molecule.dropzones.js';
import { wrapper } from './organism.input-container.style.js';
import { jsx, jsxs } from 'react/jsx-runtime';

function InputContainer(props) {
  const ref = useRef(null);
  const componentRef = useComponentRootRef();
  const [draggedTileId, setDraggedTileId] = useState();
  const update = useUpdateTaskEntryMutation();
  const dropzoneScrollerRef = useRef(null);
  const sensors = useSensors(useSensor(TouchSensor, {
    activationConstraint: {
      distance: 6
    }
  }), useSensor(MouseSensor, {
    activationConstraint: {
      distance: 6
    }
  }), useSensor(KeyboardSensor, {
    scrollBehavior: "instant"
  }));
  const handleDragStart = event => {
    setDraggedTileId(event.active.id.toString().replace(/-[^-]*?$/, ""));
  };
  const handleDragEnd = event => {
    setDraggedTileId(undefined);
    if (!event.over?.id) {
      return;
    }
    const tileId = event.active.id.toString().replace(/-[^-]*?$/, "");
    if (event.over.id === "drawer") {
      update(props.task.id, prev => {
        const next = prev ?? {};

        // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete next[tileId];
        return next;
      });
    } else {
      const targetDropzone = props.task.groups.find(it => it.id === event.over?.id);
      if (!targetDropzone) {
        return;
      }
      update(props.task.id, prev => {
        const next = prev ?? {};
        if (targetDropzone.id === groupTileInput.entry.asTypeSafe(prev?.[tileId])?.dropzoneId) {
          return next;
        }
        const prevMaxOrder = Math.max(0, ...Object.values(next).filter(it => !!groupTileInput.entry.asTypeSafe(it)).map(it => it.order));
        next[tileId] = {
          type: "group-tile",
          dropzoneId: targetDropzone.id,
          order: prevMaxOrder + 1
        };
        return next;
      });
    }
  };
  const draggedInput = props.task.content.find(it => it.id === draggedTileId);
  const restrictToComponent = useMemo(() => makeRestrictToRef(componentRef), [componentRef]);
  return /*#__PURE__*/jsx(NoSSR, {
    children: /*#__PURE__*/jsx("div", {
      ref: ref,
      className: wrapper,
      children: /*#__PURE__*/jsxs(DndContext, {
        sensors: sensors,
        onDragStart: handleDragStart,
        onDragEnd: handleDragEnd,
        onDragCancel: handleDragEnd,
        autoScroll: false,
        modifiers: [restrictToComponent],
        children: [/*#__PURE__*/jsx(DropzoneContainer, {
          taskEntryKey: props.taskEntryKey,
          scrollerRef: dropzoneScrollerRef,
          draggable: true,
          dropzones: props.task.groups,
          draggedItemKey: draggedTileId,
          tiles: props.task.content,
          facitType: "user-entry"
        }), /*#__PURE__*/jsx(TileDrawer, {
          taskEntryKey: props.taskEntryKey,
          draggable: true,
          tiles: props.task.content,
          draggedTileId: draggedTileId,
          type: "user-entry"
        }), /*#__PURE__*/jsx(OpgavekompleksetTaskDragOverlay, {
          dropAnimation: {
            duration: 0
          },
          task: props.task,
          children: draggedInput && /*#__PURE__*/jsx(GroupTile, {
            context: "overlay",
            taskEntryKey: props.taskEntryKey,
            isDraggable: true,
            isDragOverlay: true,
            tile: draggedInput
          }, draggedInput.id)
        }), /*#__PURE__*/jsx(TaskAutoScroller, {
          taskRef: ref,
          horisontalScroller: dropzoneScrollerRef
        })]
      })
    })
  });
}

export { InputContainer };
//# sourceMappingURL=organism.input-container.js.map
